// extracted by mini-css-extract-plugin
export default {"fullWidth":"Qn-z","image":"Rn-z","lazyLoadPicture":"Sn-z","lazyLoadSpinner":"Tn-z","lazyLoadSpin":"Un-z","lazyLoadImage":"Vn-z","hasStyledAspectRatio":"Wn-z"};